<template>
  <b-container fluid class="portal">
    <b-row class="row">
      <b-col id="portal-menu">
        <portalMenu />
      </b-col>
      <b-col id="content-area">
        <b-alert :show="status == 'error'" dismissible variant="danger">
          <p>{{ error_message }}...</p>
        </b-alert>
        <router-view />
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import portalMenu from "./Menu.vue";
import { mapState } from "vuex";
export default {
  name: "customerPortal",
  computed: {
    ...mapState(["status", "error_message"]),
  },
  components: {
    portalMenu,
  },
};
</script>
